import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormErrorsModule } from '@shared/components/form-elements/form-errors/form-errors.module';
import { InputFieldComponent } from '@shared/components/form-elements/input-field/input-field.component';
import { LocalLoaderComponent } from '@shared/components/loader/local-loader/local-loader.component';
import { ForgotPasswordService } from '@b2b/features/forgot-password-dialog/core/forgot-password.service';

@Component({
  selector: 'app-receive-code',
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    FormErrorsModule,
    LocalLoaderComponent,
    InputFieldComponent,
  ],
  templateUrl: './receive-code.component.html',
  styleUrl: './receive-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiveCodeComponent implements OnInit {
  @Input() username?: string;

  isLoading$ = this.forgotPasswordService.isLoading$;
  error$ = this.forgotPasswordService.error$;

  form = new FormGroup({
    username: new FormControl('', [Validators.required]),
  });

  constructor(private forgotPasswordService: ForgotPasswordService) {}

  ngOnInit(): void {
    this.form.patchValue({ username: this.username || '' });
  }

  submit() {
    if (this.form.valid) {
      this.forgotPasswordService.receiveCode(this.form.value.username!);
    }
  }
}
